import React, {lazy, Suspense} from 'react'

const MusicPageLazy = lazy(() =>
    import('./MusicPage')
)

const MusicPage = props => (
    <Suspense fallback={null}>
        <MusicPageLazy {...props} />
    </Suspense>
)

export default MusicPage
